
  import { Vue, Component } from 'vue-property-decorator'
  @Component({})
  
  export default class Reports extends Vue  {
    //Prop

    //Data
    dialog = false

    //Watch

    //Methods
    public close(): void {
      this.dialog = false
    }

    public downloadBridgeList(): void {
      this.$store.dispatch('bridge/downloadBridgeList')
    }
    public downloadBridgeEvaluation(): void {
      this.$store.dispatch('bridge/downloadBridgeEvaluation')
    }
    public downloadBridgeMaintenance(): void {
      this.$store.dispatch('bridge/downloadBridgeMaintenance')
    }

    //Emits


    //Computed
    get getErrors(): Array<string> {
      return this.$store.getters['bridge/getErrors']
    }

  }
